import styled from "styled-components";
import { TemplateTextarea } from "styles/TemplateTextarea";

export const OpeningMessageTextarea = styled(TemplateTextarea)`
  height: 160px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 2rem;
`;

export const Option = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const OptionIcons = styled.div`
  display: flex;
  align-items: flex-start;
  gap: .5rem;
`;

export const ActionsButtons = styled.div`
  display: flex;
  gap: .5rem;
`;
